import { curry } from 'ramda';

import { IConfigData } from 'shared/types/config';
import { TApplicationState } from 'shared/types/redux';

type TSelectConfigValue = (<K extends keyof IConfigData>(key: K, state: TApplicationState) => IConfigData[K]) &
  (<K extends keyof IConfigData>(key: K) => (state: TApplicationState) => IConfigData[K]);

export const selectConfigValue = curry((key: keyof IConfigData, state: TApplicationState) => {
  return state.config[key];
}) as TSelectConfigValue;
